import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useConfetti } from '../../components/useConfetti';
import Speech, { useSpeech } from 'react-text-to-speech';
import TextToSpeech from '../../components/TextToSpeech';
import { primaryColor } from '../../../assets/styles/styles';
import { db } from '../../../services/firebase_services';
import { Filter } from 'glin-profanity';

export function Stream() {
  const [name, setName] = useState('');
  const [clicked, setClicked] = useState(false);
  const [triggered, setTriggered] = useState(false);

  const [voices, setVoices] = useState<SpeechSynthesisVoice[]>([]);
  const [selectedVoice, setSelectedVoice] =
    useState<SpeechSynthesisVoice | null>(null);
  const [text, setText] = useState('Hello from your selected voice!');

  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = speechSynthesis.getVoices();
      setVoices(availableVoices);
      if (availableVoices.length > 0 && !selectedVoice) {
        setSelectedVoice(availableVoices[0]);
      }
    };

    if (speechSynthesis.getVoices().length === 0) {
      speechSynthesis.onvoiceschanged = loadVoices;
    } else {
      loadVoices();
    }
  }, [selectedVoice]);

  function startLoop() {
    let time = Math.random() * (60 - 15) + 15;
    getRandomSignup().then(val => {
      setName(val);

      setTimeout(() => {
        startLoop();
        // }, 5000);
      }, time * 1000);
    });
  }

  useEffect(() => {
    let party_num = Math.floor(Math.random() * 21) + 1;
    let audio = new Audio('/static/sounds/party' + party_num + '.mp3');

    audio.play().catch(err => {
      console.error('Audio playback failed:', err);
    });
    triggerConfetti();
  }, [name]);

  async function getRandomSignup(): Promise<string> {
    try {
      const response = await fetch('https://randomuser.me/api/');
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const data = await response.json();
      const firstName = data.results?.[0]?.name?.first;

      if (!firstName) {
        throw new Error('First name not found in API response');
      }

      return firstName;
    } catch (error) {
      console.error('Error fetching random first name:', error);
      throw error;
    }
  }
  const triggerConfetti = useConfetti(); // confetti lasts 3 seconds

  async function startListen() {
    db.ref('/new_data/user_data/users')
      .orderByChild('creationDate')
      .limitToLast(1)
      .on('value', async val => {
        console.log('Got ittt');
        let list: any[] = Object.values(val.val());
        let filter = new Filter();
        if (!filter.isProfane(list[0].firstName)) {
          setName(list[0].firstName);
        }
      });
  }
  return (
    <Grid
      container
      justifyContent={'center'}
      alignContent={'center'}
      alignItems={'center'}
      style={{ flex: 1, backgroundColor: primaryColor, height: '100vh' }}
    >
      <Typography variant="h1" fontWeight={'900'} color="white">
        Welcome, {name}!
      </Typography>
      <br />
      {!clicked && (
        <button
          onClick={() => {
            setClicked(true);
            startListen();
            startLoop();
          }}
        >
          Press
        </button>
      )}

      <TextToSpeech text={name} />
    </Grid>
  );
}
